import UTILITY_API from "../utility_api";

const getActivityCodesForMentored = (mentored, query) => {
  const matchingObjects = mentored.filter((element) =>
    query.includes(element.mentored)
  );

  const activityCodes = matchingObjects.map((obj) => ({
    mentored: obj.mentored,
    activity_codes: obj.activity_codes,
  }));

  return activityCodes.length > 0 ? activityCodes : null;
};

const fetchMentored = async (mentored_option) => {
  try {
    const mentored = await fetch(UTILITY_API + "/mentored");
    if (!mentored.ok) {
      throw new Error(`First API call failed: ${mentored.statusText}`);
    }
    const mentored_data = await mentored.json();
    const activityCodes = getActivityCodesForMentored(
      mentored_data,
      mentored_option
    );

    if (activityCodes) {
      const flattenedActivityCodes = activityCodes.flatMap(
        (obj) => obj.activity_codes
      );
      let updateDataQuery = {
        activitycodes: flattenedActivityCodes.join(","),
      };
      return updateDataQuery;
    }
  } catch (error) {
    console.error("Failed to fetch data:", error);
  }
};

export const handleMentoredHelper = async (mentored) => {
  let updateDataQuery = await fetchMentored(mentored);
  return updateDataQuery;
};
